<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">ICML 2022 | 腾讯优图实验室入选论文解读，含联邦学习、自监督模型研究方向</div>
      <div class="news-date">2022年8月12日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          <span class="mark-text">近日，腾讯优图实验室2篇论文被机器学习国际顶级会议 ICML</span>
          （International Conference on Machine Learning，国际机器学习大会）
          <span class="mark-text">所接收，涵盖联邦学习、自监督模型研究方向。</span>
        </p>
        <p>作为国际机器学习学会（IMLS）主办的机器学习国际顶级会议和 CCF-A 类学术会议。ICML 今年共收到 5630 篇投稿，接收1117 篇 short oral，118篇 long oral，录用率为21.94%。</p>
        <p>以下为腾讯优图实验室入选论文概览：</p>
        <div class="news-content-mark">
          <h2>01</h2>
          <div>标签分布有偏场景下的联邦学习</div>
          <p>Federated Learning with Label Distribution Skew via Logits Calibration</p>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news20.png"/>
          </div>
        </div>
        <p>
          传统的联邦学习优化方法对于异构数据的性能较差，特别是对于分布高度有偏的数据。在本文中，我们研究了
          <span class="mark-text">FL中的标签分布偏斜</span>
          (label distribution skew )。
        </p>
        <p>首先，我们从统计角度研究标签分布偏差。我们从理论和实验上证明，传统联邦学习基于 softmax 交叉熵的方法不适用，会导致局部模型严重过拟合少数类和缺失类。此外，我们在理论上引入了一个偏差界来测量局部更新后梯度的偏差。最后，我们提出了 FedLC 校准方法，它根据每个类的出现概率在 softmax 交叉熵之前校准 Logits 层。</p>
        <p>
          FedLC 通过添加成对标签边距，将细粒度校准后的交叉熵损失应用于局部模型的更新。在联邦数据集和真实世界数据集上的大量实验表明，FedLC 可以实现更精确的全局模型，可以大大提高性能。此外，
          <span class="mark-text">将其他FL方法集成到我们的方法中可以进一步提高全局模型的性能。</span>
        </p>
        <div class="download-article-wrap">
          <div class="download-article">
            <span class="mark-text">论文下载地址：</span>
            <a href="https://proceedings.mlr.press/v162/zhang22p.html" target="_blank" title="Federated Learning with Label Distribution Skew via Logits Calibration">https://proceedings.mlr.press/v162/zhang22p.html</a>
          </div>
        </div>
        <div class="news-content-mark">
          <h2>02</h2>
          <div>自监督模型是视觉Transformer的良好助教</div>
          <p>Self-supervised Models are Good Teaching Assistants for Vision Transformers</p>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news20_1.png"/>
          </div>
        </div>
        <p>在过去几年里， Transformer 在视觉任务上取得了显著的进展。与卷积神经网络相比，视觉 Transformer 通常需要蒸馏的帮助才能在中小规模数据集上达到可比的结果。</p>
        <p>同时，最近的研究发现，自监督训练的视觉 Transformer 和有监督训练的视觉 Transformer 捕获到的 pattern 在数量和质量上都有显著不同。这些发现激励我们在常用的有监督教师网络之外引入自监督助教网络 (SSTA) 来提升视觉 Transformer 的效果。</p>
        <p>
          具体来说，
          <span class="mark-text">我们提出了一种 head-level 的知识蒸馏方法，</span>
          选择有监督教师和自监督助教网络中最重要的 head ，让学生网络来模拟这两个 head 的注意力分布，从而使得学生网络关注在教师网络和助教网络学到的tokens之间的关系。大量的实验证明了SSTA的有效性，并证明所提出的
          <span class="mark-text">SSTA 可以和有监督教师网络很好地互补。</span>
          同时，一些在有监督教师网络、自监督助教网络和学生网络上进行的分析性实验 (如prediction、shape bias、 robustness 以及 transferability ) 都会进一步启发未来的研究。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/news20_2.png"/>
          </div>
        </div>
        <div class="download-article-wrap">
          <div class="download-article">
            <span class="mark-text">论文下载地址：</span>
            <a href="https://proceedings.mlr.press/v162/wu22c.html" target="_blank" title="Self-supervised Models are Good Teaching Assistants for Vision Transformers">https://proceedings.mlr.press/v162/wu22c.html</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News20',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .high-light {
    color: rgb(1, 82, 217);
  }
  .news-content-mark {
    margin-top: 40px;
  }
  .image-panel {
    max-width: 667px;
    text-align: center;
    margin: 20px 0px;
    span {
      font-size: 12px;
      display: block;
      color: #b9b2b9;
    }
    img {
      max-width: 667px;
    }
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News20.vue